module.exports = __webpack_public_path__ + "img/11-vogelspeelgoed.bb7ce398.jpg";